import React, {Component} from "react";

class MarketoForm extends Component {
  shouldComponentUpdate () {
    return false;
  }

  componentDidMount() {
    try {
      window.MktoForms2.loadForm("//app-abd.marketo.com", "566-JGI-821", 2299, function(form) {
        form.onSuccess(function() { return false; });
      });
    } catch (e) {
      console.warn("Cannot find Marketo in window");
      console.error(e)
    }
  }

  render () {
    return (<form id="mktoForm_2299"/>)
  }
}

export default MarketoForm;


// WEBPACK FOOTER //
// ./src/components/marketo-form/index.js